import React, {useEffect} from 'react';
import * as css from './WhatsAppScreen.css.js';
import {updateDesignEmail,updateWhatsAppMessage, updateEmailStatus, saveWhatsAppImage} from '../../../redux/branding/brandingActions';
import ModeBtn from '../../../component/modeBtn/ModeBtn';
import WhatsAppEditorWrapper from './WhatsAppEditorWrapper.js';
import {useSelector} from 'react-redux';
import {removeTagsFromText} from '../emailSubjectTextEditor/EmailSubjectTextEditor';
import WhatsAppImage from './WhatsAppImage.js';
import {IS_NEW_TEMPLATE} from '../../../config/config';
import {updateEventSettings} from '../../../redux/event/eventActions';
import {getWhatsappTemplateName, MESSAGE_TYPES} from '../menu/brandingConfig';
import {setCurrentRating} from '../../components/rating/Rating';
import {TState} from '../../../redux/store.type';
import {TBranding} from '../../../redux/branding/branding.type';
import {useBrandingParams} from '../../../hooks/useBrandingParams';
import TrialPop from '../../../component/sendingPopup/components/trialPop/TrialPop';
import {useTranslation} from 'react-i18next';
import useGlobalShow from '../../../hooks/useGlobalShow.js';

function WhatsAppScreen() {
    const {eid,eventType, defaultLang} = useSelector((s: TState) => ({
        eid: s.event.eid,
        eventType: s.event.type,
        defaultLang: s.event.lang
    }));
    const {messageType}=useBrandingParams();
    const {currentLang,data,getBrandingData} = useSelector((s: TState) => s.branding??{} as TBranding);
    const {whatsappContent,whatsappMessage, enabledWhatsapp, whatsappPrefix, whatsappSuffix, whatsappButtons, whatsappMaxLines}=data?.[currentLang]?.[messageType]??{};
    const dependencies=[currentLang,getBrandingData[`${currentLang}XHR`], messageType];
    const image = data?.[currentLang]?.[messageType]?.whatsappImage || data?.[defaultLang]?.whatsappImage;
    const newService = IS_NEW_TEMPLATE(Number(eid));
    const show = useGlobalShow('isOpenTrialPop');
    const trialPopupShow = useGlobalShow('isOpenTrialPopup');

    const isDesperateMessage = messageType === MESSAGE_TYPES.desperate;
    const {t} = useTranslation('whatsapp');

    const updateStatus = async () => {
        await updateEmailStatus('enabledWhatsapp', (enabledWhatsapp || 0) === 1 ? 0 : 1, messageType);
        await updateEventSettings('whatsAppMessage', {active: (enabledWhatsapp || 0) === 1 ? false : true, messageType, lang: currentLang}, 'ticketsMailing');
    };

    const saveText = (content) =>{
        content = content.replace(/<\/p><p>/g, '\n');
        const cleanText = removeTagsFromText(content);
        
        if(newService || isDesperateMessage){
            // For new template or desperate messages, save to eventWhatsappMessage table
            updateWhatsAppMessage(cleanText, messageType);
        } else {
            updateDesignEmail(messageType, {whatsappContent:cleanText});
        }
    };
    const text = newService ? whatsappMessage : whatsappContent;
    const defaultText = text?.replace(/\\n|\n/g, '</p><p>');
    const messageContent = `${whatsappPrefix}\n${newService ? whatsappMessage : whatsappContent}\n${whatsappSuffix}`;

    useEffect(() => {
        if(newService){
            setCurrentRating('whatsappNewService');
        }
    }, []);
    return (
        <css.wrapper data-cy={'whatsAppScreen'}>
            <css.top>
                {t('whatsappMailing')}
                <ModeBtn className={'small'} status={enabledWhatsapp} click={updateStatus} requestStatus={undefined} dataTitle={undefined} text={undefined} dataCyName={undefined}/>
            </css.top>
            <WhatsAppImage name="whatsappImage" eyeName="whatsappImage" image={image} saveImage={(image)=>saveWhatsAppImage(image, messageType)}/>
            <WhatsAppEditorWrapper
                data-cy={'whatsAppTemplateEditor'}
                defaultText={defaultText}
                dependencies={dependencies}
                events={{onSave: (content) => saveText(content)}}
                whatsappTemplate={getWhatsappTemplateName(messageType, eventType, eid)}
                limit={undefined}
                whatsappPrefix={whatsappPrefix}
                whatsappSuffix={whatsappSuffix}
                whatsappButtons={whatsappButtons}
                maxLines={whatsappMaxLines}
            />
            {show.isOpen && (
                <TrialPop
                    show={show}
                    messageContent={messageContent}
                    contactType="phone"
                    messageText={newService ? whatsappMessage : whatsappContent}
                    imagePath={image?.path || ''}
                    messageType={messageType}
                    currentLang={currentLang}
                    trialPopupShow={trialPopupShow}
                />
            )}
        </css.wrapper>
    );
}

export default WhatsAppScreen;
